<template>
  <ul 
    v-if="list.length"
    class="posts-list">
    <li 
      v-for="(post, index) of list"
      :key="index"
      class="posts-list__single-post">
      <router-link :to="{ name: 'single-post', params: { slug: post.fields.slug } }">
        <div class="swiper-slide__img-container">
          <img
            v-if="typeof post.fields.image !== 'undefined'"
            v-lazy="post.fields.image.fields.file.url"
            v-lazy:background-image="lazyLoading"
            :key="post.fields.image.fields.file.url"
            :alt="post.fields.image.fields.description"
            :width="post.fields.image.fields.file.details.image.width"
            :height="post.fields.image.fields.file.details.image.height"> 
        </div>
        <h5>{{ post.fields.title }}</h5>
      </router-link>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'PostsList',
  data: () => ({
    lazyLoading: require('@/assets/lazy/post.png')
  }),
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "./list.scss";
</style>
